import {Pill} from '@wandb/components';
import React, {useCallback, useLayoutEffect} from 'react';
import {type Descendant, Editor, Transforms} from 'slate';
import {
  Editable,
  ReactEditor,
  type RenderElementProps,
  Slate,
} from 'slate-react';

import {AGENT_NAME} from './constants';

export const WBAgentEditor = ({
  editor,
  initialValue,
  onChange,
  onKeyDown,
}: {
  editor: Editor;
  initialValue: Descendant[];
  onChange: () => void;
  onKeyDown: (e: React.KeyboardEvent) => void;
}) => {
  const renderElement = useCallback(
    (props: RenderElementProps) => <Element {...props} />,
    []
  );
  useLayoutEffect(() => {
    ReactEditor.focus(editor);
    Transforms.select(editor, Editor.end(editor, []));
  }, [editor]);

  return (
    <Slate editor={editor} initialValue={initialValue} onChange={onChange}>
      <Editable
        renderElement={renderElement}
        placeholder={`Ask ${AGENT_NAME}`}
        spellCheck
        autoFocus
        onKeyDown={onKeyDown}
        className="outline-none max-h-[180px] overflow-y-auto overscroll-none [scrollbar-color:#0d0f1252_transparent]"
      />
    </Slate>
  );
};

const Element = ({attributes, children, element}: RenderElementProps) => {
  if (element.type === 'run-mention') {
    return (
      <span {...attributes} contentEditable={false} className="align-middle">
        <Pill icon="running-repeat" textValue={element.displayName} />
        <span style={{display: 'none'}}>{children}</span>
      </span>
    );
  }
  return <div {...attributes}>{children}</div>;
};
